"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
/**
 * Handles logic to display a popup at mouse cursor position,
 * triggered by a click event.
 */
const useViewMore = () => {
    let closeTimeoutId = 0;
    const [viewMorePopup, setViewMorePopup] = React.useState(false);
    const openViewMore = React.useCallback((content) => (e) => {
        window.clearTimeout(closeTimeoutId);
        e.stopPropagation();
        setViewMorePopup({
            content,
            x: e.clientX > window.innerWidth / 2 ? e.clientX - 8 : e.clientX + 8,
            y: e.clientY > window.innerHeight / 2 ? e.clientY - 8 : e.clientY + 8,
        });
    }, [viewMorePopup, closeTimeoutId]);
    const close = () => {
        closeTimeoutId = window.setTimeout(() => setViewMorePopup(false), 150);
    };
    React.useEffect(() => () => {
        if (closeTimeoutId) {
            window.clearTimeout(closeTimeoutId);
        }
    }, [closeTimeoutId]);
    return {
        viewMorePopup,
        toggle: (content) => (viewMorePopup ? close() : openViewMore(content)),
        open: openViewMore,
        close,
    };
};
exports.default = useViewMore;
//# sourceMappingURL=useViewMore.js.map